import { TreeView } from '../components/tree/TreeView';
import { SearchInterface } from '../components/search/SearchInterface';
import { KinshipTool } from '../components/kinship/KinshipTool';
import { ImportExportPanel } from '../components/import-export/ImportExportPanel';

export function TreePage() {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="p-8">
                <h1 className="text-3xl font-bold mb-6 text-blue-600">Cây Gia Phả Việt Nam</h1>

                {/* Tree Visualization */}
                <div className="mb-8">
                    <TreeView />
                </div>

                {/* Tools Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <SearchInterface />
                    <KinshipTool />
                </div>

                {/* Import/Export */}
                <div className="mt-6">
                    <ImportExportPanel />
                </div>
            </div>
        </div>
    );
}
